<template>
  <div
    class="relative h-24 md:h-32 bg-main-header"
    v-click-outside="onClickOutside"
  >
    <div class="hidden sm:block absolute top-0 right-0 text-right z-100 m-0 md:mr-6 md:mt-2">
      <a
        href="#"
        class="flex justify-end items-center border-0 text-white font-medium no-underline"
        @click.prevent="toggleDropDown = !toggleDropDown"
      >

        <div
          class="p-2 px-4 flex justify-center items-center"
          :class="{'bg-white text-brand': toggleDropDown}"
        >
          <!-- <div
            class="mr-2 flex py-1 px-2 border rounded-full justify-center items-center"
            :class="{'border-brand': toggleDropDown, 'border-red-light bg-red-light': !toggleDropDown}"
            v-if="notif_counts.unfiled + notif_counts.discussions + notif_counts.tasks + notif_counts.events > 0"
          >
            <i
              class="fa-bell flex-none mr-1"
              :class="{'fas': toggleDropDown, 'far': !toggleDropDown}"
            ></i>
            <div class="flex-none">
              {{notif_counts.unfiled + notif_counts.discussions + notif_counts.tasks + notif_counts.events}}
            </div>
          </div> -->
          <span class="p-2 font-medium text-sm"><i class="fa fa-cog"></i> {{ fullName }}</span>

          <!-- <i
            class="fa fa-chevron-up text-brand"
            v-if="toggleDropDown"
          ></i>
          <i
            class="fa fa-chevron-down"
            v-else
          ></i> -->
        </div>
      </a>
      <div
        class="dropdown bg-white text-black shadow-lg flex flex-col"
        v-show="toggleDropDown"
      >

        <!-- <global-count-notif v-model="notif_counts"></global-count-notif> -->

        <router-link
          :to="{name: 'personal-details'}"
          class="text-base text-black py-3 px-8 font-medium no-underline text-right border-b border-grey-lighter hover:bg-brand-lightest"
          @click.native="toggleDropDown = false"
        >
          Personal Details
        </router-link>
        <router-link
          :to="{name: 'change-password'}"
          class="text-base text-black py-3 px-8 font-medium no-underline text-right border-b border-grey-lighter hover:bg-brand-lightest"
          @click.native="toggleDropDown = false"
        >
          Change password
        </router-link>
        <!-- Logout stands apart: red on a grey strip, icon that exists in Font Awesome 5 -->
        <button
          type="button"
          class="logout text-base text-red font-medium text-right py-3 px-8 bg-grey-lightest hover:bg-red hover:text-white"
          @click.prevent="logout"
        >
          <i class="fa fa-sign-out-alt mr-1"></i> Logout
        </button>
      </div>
    </div>

    <div class="flex justify-center items-center h-full text-white">
      <p
        v-if="$route.name == 'vaults'"
        class="text-3.5xl sm:text-4.5xl flex flex-row font-light"
      >
        Your Vaults
      </p>

      <div
        v-if="$route.params.vault_id != undefined && currentVault != undefined"
        class="text-2xl sm:text-4.5xl text-center"
      >
        <!-- Own line height: this block otherwise inherits the 4.5xl line height from its parent -->
        <div class="font-semibold mb-1 text-1xl leading-normal">
          <!--  @click.prevent="toggleVaultActivity = !toggleVaultActivity" -->
          <span class="no-underline text-white">
            {{currentVault.name}}
            <!-- <i class="fa fa-angle-down" v-if="!toggleVaultActivity"></i>
                        <i class="fa fa-angle-up" v-else></i> -->
          </span>

        </div>
        <p
          class="text-2xl sm:text-4xl text-center font-light"
          v-show="$route.meta.header != undefined"
        >{{$route.meta.header}}</p>
      </div>

      <div
        v-else
        class="text-2xl sm:text-4.5xl text-center font-light"
      >
        <p v-show="$route.meta.header != undefined">{{$route.meta.header}}</p>
      </div>

      <div
        class="flex justify-center items-center w-full absolute mt-8"
        :class="{'invisible': !toggleVaultActivity}"
      >
        <div class="vault-activity absolute bg-white text-black text-base w-1/2 h-32 mt-3 shadow-md border rounded p-4">
          <p class="font-medium text-xl">Vault Activity</p>
          <div
            class="bg-orange-lightest text-center border-orange text-orange-dark p-4 mt-4"
            role="alert"
          >
            <p>This feature is not yet available</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vClickOutside from "v-click-outside";
import GlobalCountNotif from "./GlobalCountNotif";

export default {
  components: {
    GlobalCountNotif
  },

  directives: {
    clickOutside: vClickOutside.directive
  },

  data () {
    return {
      toggleDropDown: false,
      toggleVaultActivity: false,

      notif_counts: {
        discussions: 0,
        tasks: 0,
        events: 0,
        unfiled: 0
      }
    };
  },

  methods: {
    setNotifCounts (payload) {
      this.notif_counts = payload;
    },
    toggleDropdown () {
      this.toggle = !this.toggle;
    },

    logout () {
      axios
        .post("/api/logout")
        .then(resp => {
          this.$store.commit("setUser", {});
          // this.$store.commit('authenticate', false);
          this.$store.commit("setVaults", []);
          this.$auth.logout();
          window.Echo.disconnect();
          window.location.href = "/auth-login";
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          }
        });
    },
    onClickOutside () {
      this.toggleVaultActivity = false;
      this.toggleDropDown = false;
    },
    onClickOutsideDropdown () {
      this.toggleDropDown = false;
    }
  },

  computed: {
    ...mapGetters({
      fullName: "getUserFullName",
      vaults: "getVaults",
      currentVault: "getCurrentVault"
    })
  }
};
</script>
